import apiService from './apiService';

export default class authService {

    static isUserAuth (token) {
        return apiService.get('/user/session', token);
    }

}
